<template>
    <vue-scroll class="page-dashboard">
        <el-row class="mt-0" :gutter="30">
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="card-base card-shadow--medium mb-30 widget small-widget" v-loading="!asyncComponent">
                    <div class="widget-header ph-20 pt-20">
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-page-next accent-text fs-40"></i>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5 pb-10">Sayfalar</div>
                                <!--<h2 class="m-0 text-truncate">{{count.yeniMesaj}}</h2>-->
                                <el-button v-on:click="route('Sayfa Listesi')" size="mini" class="margin-top-5">İncele
                                </el-button>
                            </div>
                        </div>
                    </div>
                    <component :is="asyncComponent" :type="'line'" :options='{ width: "100%", height: 80 }'
                               :data="[1, 3, 2, 4, 4, 9, 3, 4, 6, 5, 4, 6, 9, 8, 11, 12, 13, 12, 12, 14].toString()"/>
                </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="card-base card-shadow--medium mb-30 widget small-widget" v-loading="!asyncComponent">

                    <div class="widget-header ph-20 pt-20">
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-bullhorn accent-text fs-40"></i>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5 pb-10">Bültenler</div>
                                <!--<h2 class="m-0 text-truncate">{{count.yeniSiparis}}</h2>-->
                                <el-button v-on:click="route('Bülten Listesi')" size="mini" class="margin-top-5">
                                    İncele
                                </el-button>
                            </div>
                        </div>
                    </div>
                    <component :is="asyncComponent" :type="'bar'"
                               :options='{ width: "100%", height: 80, fill: ["#c6d9fd"] }'
                               :data="[1, 3, 2, 4, 4, 9, 3, 4, 6, 5, 4, 6, 9, 8, 7, 6, 5, 12, 10, 9].toString()"/>
                </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="card-base card-shadow--medium mb-30 widget small-widget" v-loading="!asyncComponent">

                    <div class="widget-header ph-20 pt-20">
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi  mdi-briefcase-plus success-text fs-30"></i>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5 pb-10">Projeler</div>
                                <el-button v-on:click="route('Proje Listesi')" size="mini" class="margin-top-5">
                                    İncele
                                </el-button>
                            </div>
                        </div>
                    </div>

                    <component :is="asyncComponent" :type="'line'"
                               :options='{ width: "100%", height: 80, fill: "#56f19a", stroke: "#67C23A" }'
                               :data="[10, 7, 8, 5, 4, 9, 3, 4, 6, 5, 4, 4, 2, 4, 5, 9, 13, 12, 12, 14].toString()"/>
                </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="card-base card-shadow--medium mb-30 widget small-widget" v-loading="!asyncComponent">

                    <div class="widget-header ph-20 pt-20">
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-email-search success-text fs-30"></i>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5 pb-10">İletişim</div>
                                    <el-button v-on:click="route('İletişim')" size="mini" class="margin-top-5">İncele</el-button>
                            </div>
                        </div>
                    </div>

                    <component :is="asyncComponent" :type="'bar'"
                               :options='{ width: "100%", height: 80, fill: ["#56f19a"] }'
                               :data="[6, 5, 4, 3, 5, 3, 4, 5, 6, 5, 4, 2, 3, 8, 7, 6, 5, 2, 1, 5].toString()"/>
                </div>
            </el-col>
        </el-row>

        <el-row class="mt-0" :gutter="30">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="card-base card-shadow--medium bg-accent p-20" style="height:400px; background: #21c1d6"
                     v-loading="!asyncChart1">
                    <h1 class="white-text mv-0 animated fadeInDown">İstatistikler</h1>
                    <h3 class="mt-0 mb-40 white-text o-050 animated slideInUp">Aylık Siparişler</h3>
                    <div id="chart1" style="height:300px; width:100%"></div>
                </div>
            </el-col>
        </el-row>

        <el-row class="mt-30" :gutter="30">
            <el-col :xs="24" :sm="12" :md="12" :lg="14" :xl="14">
                <vue-scroll class="card-base card-shadow--medium mb-30" style="height:410px">
                    <div class="p-20 flex justify-space-between">
                        <div>
                            <h2 class="mv-0 animated fadeInDown">Son İşlemler</h2>
                            <h4 class="mt-5 mb-0 o-050 animated slideInUp">Son 10 İşlem Listesi</h4>
                        </div>
                        <!--<div class="radio-switcher">-->
                        <!--<el-radio-group v-model="radio1">-->
                        <!--<el-radio-button label="Day"></el-radio-button>-->
                        <!--<el-radio-button label="Week"></el-radio-button>-->
                        <!--<el-radio-button label="Month"></el-radio-button>-->
                        <!--</el-radio-group>-->
                        <!--</div>-->
                    </div>
                    <table class="styled striped">
                        <thead>
                        <tr>
                            <th style="min-width:85px;">İşlem Türü</th>
                            <th style="min-width:80px;">İşlem</th>
                            <!--<th style="min-width:130px;">Activity</th>-->
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in list" :key="item.id">
                            <td style="min-width:80px;">{{item.turu}}</td>
                            <td style="min-width:80px;">{{item.aciklama}}</td>
                            <!--<td style="min-width:130px;">-->
                            <!--<peity :options="{fill:['#a4bbe0', '#5f8fdf']}" :type="'donut'" :data="'1/5'"></peity>-->
                            <!--<peity :options="{fill:['#a4bbe0', '#5f8fdf']}" :type="'donut'"-->
                            <!--:data="'226/360'"></peity>-->
                            <!--<peity :options="{fill:['#a4bbe0', '#5f8fdf']}" :type="'donut'"-->
                            <!--:data="'0.52/1.561'"></peity>-->
                            <!--<peity :options="{fill:['#a4bbe0', '#5f8fdf']}" :type="'donut'"-->
                            <!--:data="'0.52/1.561'"></peity>-->
                            <!--<peity :options="{fill:['#a4bbe0', '#5f8fdf']}" :type="'donut'"-->
                            <!--:data="'0.52/1.561'"></peity>-->
                            <!--</td>-->
                        </tr>
                        </tbody>
                    </table>
                </vue-scroll>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="10" :xl="10">
                <vue-scroll class="card-base card-shadow--medium mb-30" style="height:410px">
                    <div class="p-20 flex justify-space-between">
                        <div>
                            <h2 class="mv-0 animated fadeInDown">Yönetici Listesi</h2>
                            <!--<h4 class="mt-5 mb-0 o-050 animated slideInUp">Son 10 İşlem Listesi</h4>-->
                        </div>
                        <!--<div class="radio-switcher">-->
                        <!--<el-radio-group v-model="radio1">-->
                        <!--<el-radio-button label="Day"></el-radio-button>-->
                        <!--<el-radio-button label="Week"></el-radio-button>-->
                        <!--<el-radio-button label="Month"></el-radio-button>-->
                        <!--</el-radio-group>-->
                        <!--</div>-->
                    </div>
                    <table class="styled striped">
                        <thead>
                        <tr>
                            <th style="min-width:85px;">Ad Soyad</th>
                            <th style="min-width:80px;">Görev</th>
                            <th style="min-width:80px;">Telefon</th>
                            <!--<th style="min-width:130px;">Activity</th>-->
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in yonetimListe" :key="item.id">
                            <td style="min-width:80px;">{{item.adSoyad}}</td>
                            <td style="min-width:80px;">{{item.gorev}}</td>
                            <td style="min-width:80px;">{{item.sabitTelefon}}</td>
                            <!--<td style="min-width:130px;">-->
                            <!--<peity :options="{fill:['#a4bbe0', '#5f8fdf']}" :type="'donut'" :data="'1/5'"></peity>-->
                            <!--<peity :options="{fill:['#a4bbe0', '#5f8fdf']}" :type="'donut'"-->
                            <!--:data="'226/360'"></peity>-->
                            <!--<peity :options="{fill:['#a4bbe0', '#5f8fdf']}" :type="'donut'"-->
                            <!--:data="'0.52/1.561'"></peity>-->
                            <!--<peity :options="{fill:['#a4bbe0', '#5f8fdf']}" :type="'donut'"-->
                            <!--:data="'0.52/1.561'"></peity>-->
                            <!--<peity :options="{fill:['#a4bbe0', '#5f8fdf']}" :type="'donut'"-->
                            <!--:data="'0.52/1.561'"></peity>-->
                            <!--</td>-->
                        </tr>
                        </tbody>
                    </table>
                </vue-scroll>
            </el-col>
            <!--<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">-->
            <!--<div class="card-base card-shadow&#45;&#45;medium mb-30">-->
            <!--<div id="pie" :style="{height:'410px',width:'100%'}"></div>-->
            <!--</div>-->
            <!--</el-col>-->
            <!--<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">-->
            <!--<div class="card-base card-shadow&#45;&#45;medium mb-30">-->
            <!--<div id="pie1" :style="{height:'410px',width:'100%'}"></div>-->
            <!--</div>-->
            <!--</el-col>-->
            <!--<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">-->
            <!--<div class="card-base card-shadow&#45;&#45;medium mb-30">-->
            <!--<div id="pie2" :style="{height:'410px',width:'100%'}"></div>-->
            <!--</div>-->
            <!--</el-col>-->
        </el-row>
        <el-row class="mt-0" :gutter="30">
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="card-base card-shadow--medium mb-30 widget small-widget" v-loading="!asyncComponent">

                    <div class="widget-header ph-20 pt-20">
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-account-multiple accent-text fs-30"></i>
                                <div class="badge-box">
                                    <span class="badge"><i class="mdi mdi-trending-up success-text mr-10"></i><strong
                                            class="accent-text">16%</strong></span>
                                </div>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5 pb-10">Toplam Kategori</div>
                                <h2 class="m-0 text-truncate">{{count.urunKategori}}</h2>
                                <router-link :to="{ path:'/urun/kategori/liste'}">
                                    <el-button size="mini" class="margin-top-5">İncele</el-button>
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <component :is="asyncComponent" :type="'line'" :options='{ width: "100%", height: 80 }'
                               :data="[1, 3, 2, 4, 4, 9, 3, 4, 6, 5, 4, 6, 9, 8, 11, 12, 13, 12, 12, 14].toString()"/>
                </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="card-base card-shadow--medium mb-30 widget small-widget" v-loading="!asyncComponent">

                    <div class="widget-header ph-20 pt-20">
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-eye accent-text fs-30"></i>
                                <div class="badge-box">
                                    <span class="badge"><i class="mdi mdi-trending-up success-text mr-10"></i><strong
                                            class="accent-text">11%</strong></span>
                                </div>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5 pb-10">Toplam Ürün</div>
                                <h2 class="m-0 text-truncate">{{count.urun}}</h2>
                                <router-link :to="{ path:'/urun/liste'}">
                                    <el-button size="mini" class="margin-top-5">İncele</el-button>
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <component :is="asyncComponent" :type="'bar'"
                               :options='{ width: "100%", height: 80, fill: ["#c6d9fd"] }'
                               :data="[1, 3, 2, 4, 4, 9, 3, 4, 6, 5, 4, 6, 9, 8, 7, 6, 5, 12, 10, 9].toString()"/>
                </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="card-base card-shadow--medium mb-30 widget small-widget" v-loading="!asyncComponent">

                    <div class="widget-header ph-20 pt-20">
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-account-convert success-text fs-30"></i>
                                <div class="badge-box">
                                    <span class="badge"><i class="mdi mdi-trending-neutral info-text mr-10"></i><strong
                                            class="success-text">1%</strong></span>
                                </div>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5 pb-10">Sayfalar</div>
                                <h2 class="m-0 text-truncate">{{count.sayfa}}</h2>
                                <router-link :to="{ path:'/sayfa/liste'}">
                                    <el-button size="mini" class="margin-top-5">İncele</el-button>
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <component :is="asyncComponent" :type="'line'"
                               :options='{ width: "100%", height: 80, fill: "#56f19a", stroke: "#67C23A" }'
                               :data="[10, 7, 8, 5, 4, 9, 3, 4, 6, 5, 4, 4, 2, 4, 5, 9, 13, 12, 12, 14].toString()"/>
                </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="card-base card-shadow--medium mb-30 widget small-widget" v-loading="!asyncComponent">

                    <div class="widget-header ph-20 pt-20">
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-cash-multiple success-text fs-30"></i>
                                <div class="badge-box">
                                    <span class="badge"><i class="mdi mdi-trending-neutral info-text mr-10"></i><strong
                                            class="success-text">0%</strong></span>
                                </div>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5 pb-10">Referanslar-Bayiler</div>
                                <h2 class="m-0 text-truncate">{{count.referans}} - {{count.bayi}}</h2>
                                <router-link :to="{ path:'/referans/liste'}">
                                    <el-button size="mini" class="margin-top-5">İncele</el-button>
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <component :is="asyncComponent" :type="'bar'"
                               :options='{ width: "100%", height: 80, fill: ["#56f19a"] }'
                               :data="[6, 5, 4, 3, 5, 3, 4, 5, 6, 5, 4, 2, 3, 8, 7, 6, 5, 2, 1, 5].toString()"/>
                </div>
            </el-col>
        </el-row>
    </vue-scroll>
</template>

<script>
    import echarts from 'echarts'
    import dashboardService from '../../WSProvider/DashboardService';
    import islemService from '../../WSProvider/IslemService';
    import yonetimService from '../../WSProvider/YoneticiService';
    import notification from '../../notification'

    export default {
        name: 'Dashboard',
        data() {
            return {
                count: {},
                asyncComponent: 'peity',
                asyncChart1: true,
                chart1: null,
                pie: null,
                list: [],
                yonetimListe: [],
                radio1: 'Month',
                radio2: 'Week',
            }
        },
        methods: {
            route(name) {
                var tabList = this.$store.state.tabList;
                var header = linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            initPie() {
                this.pie = echarts.init(document.getElementById('pie'))
                this.pie.setOption({
                    title: {
                        top: 20,
                        text: 'Kategoriler',
                        textStyle: {fontWeight: 'normal', fontSize: 16, fontFamily: 'Nunito Sans' /*color: '#F1F1F3'*/},
                        left: '1%'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    series: [
                        {
                            name: 'Status',
                            type: 'pie',
                            selectedMode: 'single',
                            radius: [0, '35%'],

                            label: {
                                normal: {
                                    position: 'inner'
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            data: [
                                {
                                    value: 335,
                                    name: 'Orders',
                                    selected: true,
                                    itemStyle: {normal: {color: 'rgb(95, 143, 223)',}}
                                },
                                {value: 679, name: 'Pending', itemStyle: {normal: {color: 'rgb(19, 206, 102)',}}},
                                {value: 1548, name: 'Delivered', itemStyle: {normal: {color: 'rgb(247, 186, 43)',}}}
                            ],
                        },
                        {
                            name: 'Products',
                            type: 'pie',
                            radius: ['45%', '60%'],

                            data: [
                                {value: 335, name: 'p1', itemStyle: {normal: {color: '#3f84f6',}}},
                                {value: 310, name: 'p2', itemStyle: {normal: {color: '#4c8bf7',}}},
                                {value: 234, name: 'p3', itemStyle: {normal: {color: '#5a95f7',}}},
                                {value: 135, name: 'p4', itemStyle: {normal: {color: '#70a3f8',}}},
                                {value: 1048, name: 'p5', itemStyle: {normal: {color: '#8ab4fa',}}},
                                {value: 251, name: 'p6', itemStyle: {normal: {color: '#a3c4fb',}}},
                                {value: 147, name: 'p7', itemStyle: {normal: {color: '#bfd6fc',}}},
                                {value: 102, name: 'p8', itemStyle: {normal: {color: '#d4e4fd',}}}
                            ],

                            itemStyle: {
                                normal: {
                                    color: 'rgb(19, 206, 102)',
                                }
                            },
                        }
                    ]
                })
            },
            initChart1() {
                this.chart1 = echarts.init(document.getElementById('chart1'))

                // Generate data
                let category = [];
                let dottedBase = +new Date();
                let lineData = [];
                let barData = [];

                for (let i = 0; i < 6; i++) {
                    let date = new Date(dottedBase += 3600 * 24 * 1000);
                    category.push([
                        date.getDate(),
                        date.getMonth() + 1,
                        date.getFullYear(),
                    ].join('-'));
                    let b = Math.random() * 200;
                    let d = Math.random() * 200;
                    barData.push(parseInt(b))
                    lineData.push(parseInt(d + b));
                }


                this.chart1.setOption({
                    //backgroundColor: '#0f375f',
                    grid: {
                        show: false,
                        left: '20px',
                        right: '50px',
                        bottom: '20px',
                        top: '20px',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    legend: {
                        show: false,
                        data: ['line', 'bar'],
                        textStyle: {
                            color: '#ccc'
                        }
                    },
                    xAxis: {
                        data: category,
                        boundaryGap: false,
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(255,255,255,0.5)'
                            }
                        }
                    },
                    yAxis: {
                        splitLine: {show: false},
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(255,255,255,0.5)'
                            }
                        }
                    },
                    series: [
                        {
                            name: 'Data A',
                            type: 'line',
                            smooth: true,
                            showAllSymbol: true,
                            symbol: 'emptyCircle',
                            symbolSize: 10,
                            lineStyle: {
                                color: '#fff'
                            },
                            itemStyle: {
                                color: '#fff',
                                borderColor: '#5f8fdf',
                                borderWidth: 3
                            },
                            areaStyle: {
                                color: 'rgba(255,255,255,0.2)'
                            },
                            animationDuration: 2800,
                            animationEasing: 'cubicInOut',
                            data: lineData
                        },
                        {
                            name: 'Data B',
                            type: 'bar',
                            barWidth: 10,
                            itemStyle: {
                                normal: {
                                    barBorderRadius: 5,
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 0, 1,
                                        [
                                            {offset: 0, color: '#fff'},
                                            {offset: 1, color: 'rgba(255,255,255,0)'}
                                        ]
                                    )
                                }
                            },
                            data: barData
                        },
                        {
                            name: 'line',
                            type: 'bar',
                            barGap: '-100%',
                            barWidth: 10,
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 0, 1,
                                        [
                                            {offset: 0, color: 'rgba(20,200,212,0.5)'},
                                            {offset: 0.2, color: 'rgba(20,200,212,0.2)'},
                                            {offset: 1, color: 'rgba(20,200,212,0)'}
                                        ]
                                    )
                                }
                            },
                            z: -12,
                            data: lineData
                        },
                        {
                            name: 'Data C',
                            type: 'pictorialBar',
                            symbol: 'rect',
                            itemStyle: {
                                normal: {
                                    color: 'rgba(255,255,255,0.1)'
                                }
                            },
                            symbolRepeat: true,
                            symbolSize: [12, 4],
                            symbolMargin: 1,
                            z: -10,
                            data: lineData
                        }
                    ]
                })
            },
            destroyChart1() {
                if (this.chart1) {
                    this.chart1.dispose()
                    this.chart1 = null
                }
            },
            getCount() {
                dashboardService.countDash().then((response) => {
                    if (response.status === 200) {
                        this.count = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            islemListesi() {
                islemService.islemListesi().then((response) => {
                    if (response.status === 200) {
                        this.list = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            yonetimList() {
                yonetimService.yoneticiList().then((response) => {
                    if (response.status === 200) {
                        this.yonetimListe = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            }
        },
        mounted() {
            this.initChart1()
            this.initPie();
            // this.getCount();
            // this.islemListesi();
            // this.yonetimList();
        },
        beforeDestroy() {
            this.destroyChart1()
            if (!this.pie) {
                return
            }
            this.pie.dispose()
            this.pie = null
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables';

    .widget {
        height: 200px;
        position: relative;

        .widget-header {

            .widget-icon-box {
                background: rgba(0, 0, 0, .02);
                border: 1px solid rgba(0, 0, 0, .02);
                border-radius: 4px;
                text-align: center;
                width: 60px;
                padding: 5px;
            }

            .widget-title {
                font-weight: bold;
            }
        }


        .badge-box {
            .badge {
                //background: rgba(0, 0, 0, .02);
                display: inline-block;
                //padding: 2px 5px;
                //border: 1px solid rgba(0, 0, 0, .02);
                border-radius: 4px;
                font-size: 80%;
            }
        }
    }

    @media (min-width: 768px) and (max-width: 1040px) {
        .radio-switcher {
            display: none;
        }

        .widget {
            .widget-header {
                .widget-icon-box {
                    display: none;
                }
            }
        }
    }

    @media (max-width: 420px) {
        .radio-switcher {
            display: none;
        }
    }
</style>

<style lang="scss">
    .bg-accent {
        background-color: #21c1d666 !important;
    }

    ;
    .page-dashboard {

        .widget {
            .peity {
                position: absolute;
                bottom: -1px;
                left: 0;
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;
            }
        }

        table.styled {
            .peity {
                margin-right: 10px;
            }
        }

        .vb-content {
            padding: 0 20px;
            box-sizing: border-box !important;
            margin-top: -5px;
            margin-left: -20px;
            margin-right: -20px;
            height: calc(100% + 15px) !important;
            width: calc(100% + 40px) !important;
        }
    }

    @media (max-width: 768px) {
        .page-dashboard {
            .vb-content {
                padding: 0 5px !important;
                margin: -5px;
                width: calc(100% + 10px) !important;
            }
        }
    }
</style>


